import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Check — confirmations, completed steps. */
export function CheckIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M4.5 12.8 9.6 18 19.5 6.5" />
    </PortalIcon>
  );
}
